import { Directive, Input, TemplateRef, ViewContainerRef, AfterViewInit } from '@angular/core';
import { WlxTabComponent } from './tab.component';
import { TabsController } from './tabs.service';

/**
 * render a content tab (in the tab well, not a tab's content)
 */
@Directive({
  selector: '[wlx-tab-well-content-view]',
  standalone: true
})
export class TabWellContentViewDirective implements AfterViewInit {
  @Input() public tab: WlxTabComponent = null;

  public constructor(public _viewContainerRef: ViewContainerRef) {}

  /**
   * triggered after all child views are created
   */
  ngAfterViewInit(): void {
    setTimeout(() => this.initContentTemplate());
  }

  public initContentTemplate(): void {
    if (!this.tab || !this.tab.isTabWellContent) return;

    // inform the developer that they used this incorrectly
    if (!this.tab.template)
      throw new Error(
        'Wl-Tab error: When using isTabWellContent="true" the child element must be a <template> tag. Put your html markup or components in the <template> tag.'
      );

    this._viewContainerRef.clear();
    this._viewContainerRef.createEmbeddedView(this.tab.template, 0);
  }
}
